<script setup lang="ts">
import { provide, toRef } from 'vue'
import { ToggleGroupKey, type ToggleValue, type ToggleGroupCtx } from './shared/toggleGroupContext'

const props = defineProps<{
  modelValue?: ToggleValue | null
  disabled?: boolean
  changeOnHover?: boolean
}>()
const emit = defineEmits<{ 'update:modelValue':[ToggleValue | null] }>()
const selected = toRef(props, 'modelValue')

function select(v: ToggleValue) {
  if (props.disabled) return
  if (selected.value !== v) emit('update:modelValue', v)
}

const ctx: ToggleGroupCtx = {
  selected: () => selected.value ?? null,
  select,
  name: `tgl-${Math.random().toString(36).slice(2)}`,
  disabled: props.disabled,
  changeOnHover: props.changeOnHover ?? false,
}

provide(ToggleGroupKey, ctx)
</script>

<template>
    <slot />
</template>
